document.documentElement.classList.add('js');

class ProductSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.move(-1));
    this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.move(1));
  }
  move(direction) {
    const card = this.track?.querySelector('.product-card');
    if (!this.track || !card) return;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }
}
customElements.define('product-slider', ProductSlider);

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.querySelector('.product-card') || !this.dataset.url) return;
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('product-recommendations');
        if (replacement?.innerHTML.trim()) this.innerHTML = replacement.innerHTML;
      })
      .catch(() => {});
  }
}
customElements.define('product-recommendations', ProductRecommendations);

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const header = button.closest('.header');
    const open = header.classList.toggle('is-menu-open');
    button.setAttribute('aria-expanded', String(open));
  });
});

document.addEventListener('error', (event) => {
  if (event.target.matches('.product-card__secondary')) {
    event.target.closest('.product-card')?.classList.add('is-secondary-error');
  }
}, true);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const status = document.querySelector('.theme-status');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (status) status.textContent = button.dataset.loadingText;
  try {
    const response = await fetch(form.action, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Cart request failed');
    if (status) status.textContent = button.dataset.successText;
  } catch (error) {
    if (status) status.textContent = button.dataset.errorText;
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (status) {
      status.classList.add('is-visible');
      window.setTimeout(() => status.classList.remove('is-visible'), 3000);
    }
  }
});

document.querySelectorAll('[data-gallery-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const main = document.querySelector('[data-gallery-main]');
    const template = button.querySelector('template');
    if (!main || !template) return;
    main.replaceChildren(template.content.cloneNode(true));
    document.querySelectorAll('[data-gallery-button]').forEach((item) => item.setAttribute('aria-current', 'false'));
    button.setAttribute('aria-current', 'true');
  });
});

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!reducedMotion && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.animate-in').forEach((element) => observer.observe(element));
} else {
  document.querySelectorAll('.animate-in').forEach((element) => element.classList.add('is-visible'));
}
